export default {
  // SEO
  'about.seo.title': '¿Quiénes son Andrew y Tristan Tate? | Tate Protest',
  'about.seo.description': 'Una visión general de Andrew y Tristan Tate: sus trayectorias, los procedimientos legales en Rumanía, el Reino Unido y los Estados Unidos, y las preguntas planteadas por los seguidores sobre el debido proceso y el trato justo.',

  // Hero
  'about.hero.title': '¿Quiénes son Andrew y Tristan Tate?',
  'about.hero.subtitle': 'Una visión general de las personas, los procedimientos legales y las pruebas que rodean una de las investigaciones criminales internacionales más controvertidas de la historia reciente.',

  // Tarjetas de perfil
  'about.andrew.title': 'Andrew Tate',
  'about.andrew.body': 'Andrew Tate es un empresario británico-estadounidense, ex cuádruple campeón mundial de kickboxing y personalidad en línea. Tras retirarse del deporte profesional, construyó varios negocios y se convirtió en una de las figuras más reconocibles en las redes sociales.',
  'about.tristan.title': 'Tristan Tate',
  'about.tristan.body': 'Tristan Tate es un empresario británico-estadounidense y ex kickboxer profesional. Se ha asociado con Andrew Tate en múltiples proyectos empresariales y aparece con frecuencia en entrevistas hablando de negocios, cultura y actualidad.',
  'about.learnMore': 'Más información',

  // Procedimientos legales
  'about.legal.title': 'Los procedimientos legales',
  'about.legal.romania': 'Rumanía',
  'about.legal.uk': 'Reino Unido',
  'about.legal.us': 'Estados Unidos',
  'about.legal.ro.arrest': 'Detención',
  'about.legal.ro.indictment': 'Acusación formal',
  'about.legal.ro.appeals': 'Apelaciones',
  'about.legal.currentStatus': 'Estado actual',
  'about.legal.uk.charges': 'Cargos penales',
  'about.legal.uk.extradition': 'Solicitud de extradición',
  'about.legal.us.arrest': 'Detención en Florida',
  'about.legal.us.federal': 'Procedimientos federales',
  'about.legal.explore': 'Explorar cronología',

  // Preguntas planteadas
  'about.questions.title': 'Preguntas planteadas por los seguidores',
  'about.questions.body': 'Los seguidores sostienen que las investigaciones han planteado preguntas sobre el debido proceso, los procedimientos legales prolongados, la divulgación de pruebas, la cobertura mediática y las motivaciones políticas. Los críticos rebaten esas afirmaciones y sostienen que las acusaciones deben resolverse en los tribunales. Este sitio web documenta información disponible públicamente para que los lectores puedan examinar el material y sacar sus propias conclusiones.',
  'about.questions.viewEvidence': 'Ver las pruebas',

  // Fundador
  'about.founder.label': 'Fundado por',
  'about.founder.name': 'Wil Pujols',
  'about.founder.before': 'Empresario de Florida y primo de la leyenda de la MLB',
  'about.founder.name2': 'Albert Pujols',
  'about.founder.after': '. Wil creó Tate Protest para llamar la atención sobre los procedimientos legales en curso y abogar por el debido proceso, la transparencia y el trato justo de Andrew y Tristan Tate.',
  'about.founder.learnMore': 'Más sobre Wil',

  // Estadísticas
  'about.stats.title': 'El caso en cifras',
  'about.stats.yearsLabel': 'Años bajo investigación',
  'about.stats.yearsSubtitle': '2015 hasta la actualidad',
  'about.stats.countries': 'Países involucrados',
  'about.stats.hearings': 'Audiencias judiciales',
  'about.stats.proceedings': 'Procedimientos legales',

  // Llamado a la acción
  'about.cta.title': 'Cada voz importa',
  'about.cta.body': 'Únete a miles de personas en todo el mundo que defienden el debido proceso y los derechos humanos. Los hermanos Tate merecen un proceso legal justo y transparente.',
  'about.cta.faq': 'Leer las preguntas frecuentes',
  'about.cta.getInvolved': 'Participa',
};